import { Pie } from "react-chartjs-2";
import React from "react";

const PieChart = ({ data }) => {
  let value = { labels: [], datasets: [{ data: [], backgroundColor: [] }] };
  if (data && data.length > 0) {
    value.labels = data.map((element) => element.map_type_name);
    value.datasets = [
      {
        data: data.map((element) => element.count),
        backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56"],
      },
    ];
  }
  const options = {
    title: {
      display: true,
      text: "Project Count with respect to map type",
      fontSize: 18, // Title font size
      fontColor: "#333", // Title color
    },
    responsive: true,
  };
  return <Pie data={value} options={options} />;
};

export default PieChart;
